import { replaceCurly } from '@eika-infrastruktur/format';

import { DeviceType } from '@generated-types';
import { KortbetjeningText } from '@hooks/use-text';
import { removeDuplicates } from '@utils/array';

const getDeviceStrings = (texts: KortbetjeningText, devices: (DeviceType | string)[]) => {
    const deviceStringArray = [
        ...(devices.some((device) =>
            [DeviceType.MOBILEPHONE_OR_TABLET, DeviceType.MOBILE_PHONE].includes(device as DeviceType),
        )
            ? [texts.iPhone]
            : []),
    ];
    if (devices.includes(DeviceType.TABLET)) deviceStringArray.push(texts.iPad);
    if (devices.includes(DeviceType.WATCH)) deviceStringArray.push(texts.watch);

    if (deviceStringArray.length === 3) {
        const lastTwoEntries = deviceStringArray.slice(1).join(` ${texts.and} `);
        return `${deviceStringArray[0]}, ${lastTwoEntries}`;
    }
    if (deviceStringArray.length === 2) return deviceStringArray.join(` ${texts.and} `);
    if (deviceStringArray.length === 1) return deviceStringArray[0];
    return '';
};

const generateHasPendingCardTokensText = (
    texts: KortbetjeningText,
    activeDevices: DeviceType[] | string[],
    devicesThatNeedVerification: DeviceType[],
) => {
    const filteredPendingTokens = removeDuplicates(
        devicesThatNeedVerification.includes(DeviceType.MOBILEPHONE_OR_TABLET)
            ? [
                  ...devicesThatNeedVerification.filter((token) => token !== DeviceType.MOBILEPHONE_OR_TABLET),
                  DeviceType.MOBILE_PHONE,
              ]
            : devicesThatNeedVerification,
    );
    if (filteredPendingTokens.length === 0) return '';
    if (activeDevices.length > 0) {
        const deviceStringArray = getDeviceStrings(texts, filteredPendingTokens);
        return replaceCurly(texts.butTheseLacksVerification, deviceStringArray);
    }
    if (filteredPendingTokens.length === 2) return texts.butBothLacksVerification;

    if (filteredPendingTokens.length === 3) return texts.butAllLacksVerification;
    return texts.butLacksVerification;
};

export const generateAddedToWalletText = (
    texts: KortbetjeningText,
    devicesAddedOn: DeviceType[] | string[],
    devicesThatNeedVerification: DeviceType[],
) => {
    const allDevicesAdded = removeDuplicates([...devicesAddedOn, ...devicesThatNeedVerification]);

    const deviceStrings = getDeviceStrings(texts, allDevicesAdded);

    const pendingCardString = generateHasPendingCardTokensText(texts, devicesAddedOn, devicesThatNeedVerification);

    return replaceCurly(texts.cardAddedToWalletOn, deviceStrings, pendingCardString);
};
